<template>
  <view-homepage />
</template>

<script>
import ViewHomepage from '../../../../components/ViewHomepage.vue';

export default {
  name: 'Preview',
  components: { ViewHomepage },
  beforeRouteLeave(to, from, next) {
    next(false);
  },
  setup() {
    definePageMeta({
      middleware: ['preview-auth'],
    });
  },
};
</script>
